// removed by extract-text-webpack-plugin
module.exports = {"NavbarWrapper":"Navbar-module__NavbarWrapper__2EI54","NavbarWrapperLandscapeLanding":"Navbar-module__NavbarWrapperLandscapeLanding__W1XNK","FromLandscapeModal":"Navbar-module__FromLandscapeModal__2RfQq Navbar-module__NavbarWrapper__2EI54","Navbar":"Navbar-module__Navbar__1jNDZ","LeftNav":"Navbar-module__LeftNav__85Phh","CenterNav":"Navbar-module__CenterNav__3lhp3","RightNav":"Navbar-module__RightNav__2gS4f","Round":"Navbar-module__Round__23rAr"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/Navbar/Navbar.module.css
// module id = 1701
// module chunks = 31